// LivreursShiftsService.js
import api from '../../utils/ApiConfig';

// Fetch all shifts with filters
const fetchShifts = async (filters = {}, page = 1, perPage = 20) => {
  try {
    const params = {
      page,
      per_page: perPage,
      ...filters
    };

    const response = await api.get(`/admin/shifts`, { params });

    if (response.data.error) {
      throw new Error(response.data.error);
    }

    return response.data;
  } catch (error) {
    console.error('Error fetching shifts:', error);
    throw error;
  }
};

// Fetch shift details with GPS history
const fetchShiftDetails = async (shiftId) => {
  try {
    const response = await api.get(`/admin/shift/${shiftId}/history`);

    if (response.data.error) {
      throw new Error(response.data.error);
    }

    return response.data;
  } catch (error) {
    console.error('Error fetching shift details:', error);
    throw error;
  }
};

// Fetch shift with deliveries details
const fetchShiftWithDeliveries = async (shiftId) => {
  try {
    const response = await api.get(`/admin/shift/${shiftId}`);

    if (response.data.error) {
      throw new Error(response.data.error);
    }

    return response.data;
  } catch (error) {
    console.error('Error fetching shift with deliveries:', error);
    throw error;
  }
};

// Fetch all livreurs for the filter dropdown
const fetchAllLivreurs = async () => {
  try {
    const response = await api.get(`/bo/getAllLivreur`);

    if (response.data.error) {
      throw new Error(response.data.error);
    }

    return response.data;
  } catch (error) {
    console.error('Error fetching livreurs:', error);
    throw error;
  }
};

// Delete a shift (superadmin only)
const deleteShift = async (shiftId) => {
  try {
    const response = await api.delete(`/admin/shift/${shiftId}`);

    if (response.data.error) {
      throw new Error(response.data.error);
    }

    return response.data;
  } catch (error) {
    console.error('Error deleting shift:', error);
    throw error;
  }
};

// Export methods
export { fetchShifts, fetchShiftDetails, fetchShiftWithDeliveries, fetchAllLivreurs, deleteShift };
